import { render, staticRenderFns } from "./PortfolioTwo.vue?vue&type=template&id=a4b84b82&scoped=true"
import script from "./PortfolioTwo.vue?vue&type=script&lang=js"
export * from "./PortfolioTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b84b82",
  null
  
)

export default component.exports